import Layout from '@layouts/Layout';
import CookiePolicy from '@screens/Legal/CookiePolicy';

import React, { memo } from 'react';

const title = 'Cookie policy';
const description = 'Learn how Traqq uses cookies to improve website performance, provide essential features, and deliver relevant content. Read our Cookie Policy for details on analytics, advertising, and functional cookies.';

const CookiePage = () => (
    <Layout
        title={ title }
        description={ description }
    >
        <CookiePolicy />
    </Layout>
);

export default memo(CookiePage);
